import {BillingRegion} from "@irati/types"
import PurchaseCurrencies, {DEFAULT_CURRENCY} from "../enums/PurchaseCurrencies"

const getCurrencyByRegionId = (regionId: string) => {
  const regionToCompare = regionId.toLowerCase() as BillingRegion
  const foundCurrency = Object.entries(PurchaseCurrencies).find(([, regions]) => {
    return regions.includes(regionToCompare)
  })
  return foundCurrency?.[0] ? foundCurrency[0] : DEFAULT_CURRENCY
}
export default getCurrencyByRegionId
